import { render, staticRenderFns } from "./MediaStat.vue?vue&type=template&id=66dbaefa&scoped=true&"
import script from "./MediaStat.vue?vue&type=script&lang=js&"
export * from "./MediaStat.vue?vue&type=script&lang=js&"
import style0 from "./MediaStat.vue?vue&type=style&index=0&id=66dbaefa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dbaefa",
  null
  
)

export default component.exports